export default __webpack_public_path__ + "static/media/object_detection.42e8521a.png";